if (!customElements.get('nav-slider')) {
  class NavSlider extends HTMLElement {
    static selectors = {
      slider: '[js-nav-slider]'
    }

    constructor() {
      super();
    }

    initSlider() {
      if(!this.drawer.classList.contains('js-nav-drawer')) return;

      this.slider = new themeVendor.Flickity(NavSlider.selectors.slider, {
        cellAlign: 'left',
        contain: true,
        pageDots: false,
        prevNextButtons: false,
      });
    }

    connectedCallback() {
      this.drawer = this.closest('.drawer');

      const config = { attributes: true, childList: true, subtree: true };

      const observer = new MutationObserver(this.initSlider.bind(this));

      observer.observe(this.drawer, config);
    }
  }
  customElements.define('nav-slider', NavSlider);
}